import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import { getOuByLocationID } from '../../helper/api/api';
import toast from 'react-hot-toast';
import { changeRole } from '../../helper/api/iamApi';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

export default function ChangeRoleModal({ open, onClose }) {
  const [role, setRole] = useState(null); // { RoleId, RoleName }
  const [ou, setOu] = useState(null);     // { LocationId, Location }

  const getUserMapping = JSON.parse(localStorage.getItem('userSwitchData')) || [];
  const token = localStorage.getItem("token");

  const uniqueRoles = Array.from(
    new Map(getUserMapping?.map((m) => [m.RoleId, m])).values()
  );

  const filteredOUs = role
    ? getUserMapping?.filter((m) => m.RoleId === role.RoleId)
    : [];

  const handleSubmit = async () => {
    if (!role || !ou) {
      toast.error('Please select both Role and OU.');
      return;
    }

    const selectedMapping = getUserMapping.find(
      (m) => m.RoleId === role.RoleId && m.LocationId === ou.LocationId
    );

    if (!selectedMapping) {
      toast.error('Invalid Role and OU combination!');
      return;
    }

    try {
      await changeRole(role.RoleId, token).then(async (response) => { 
        localStorage.removeItem('Privilliages');
        localStorage.setItem('Privilliages', JSON.stringify(response?.data));

        const ouResponse = await getOuByLocationID(ou.LocationId);
        const ouData = ouResponse?.data?.data;

        const userData = JSON.parse(localStorage.getItem("userData"));
        if (Array.isArray(userData) && userData.length > 0) {
          userData[0].OU = ouData?.[0]?.OU;
          userData[0].CompanyLogo = ouData?.[0]?.CompanyLogo;
          userData[0].TextLogo = ouData?.[0]?.TextLogo;
          userData[0].PayslipLogo = ouData?.[0]?.PayslipLogo;
          userData[0].LocationName = ou.Location;
          userData[0].Iamlocation = ouData?.[0]?.Iamlocation;
          userData[0].LocationId = ouData?.[0]?.Iamlocation;
          userData[0].Role = role.RoleId;
          userData[0].RoleId = role.RoleId;
          userData[0].RoleName = role.RoleName;
          localStorage.setItem("userData", JSON.stringify(userData));
        }
        window.location.reload();
        onClose();
      });
    } catch (error) {
      toast.error(error?.message || 'Unable to switch account!');
      if (error === 'Token Expired') {
        localStorage.clear();
        window.location.href = "/login";
      }
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Change Role
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }} size="small">
          <InputLabel shrink sx={{background: '#fff', px:1}}>Role</InputLabel>
          <Select
            value={role ? JSON.stringify(role) : ''}
            onChange={(e) => {
              setRole(JSON.parse(e.target.value));
              setOu(null);
            }}
            sx={{ height: '30px' }}
          >
            {uniqueRoles.map((r, i) => (
              <MenuItem
                key={i}
                value={JSON.stringify({ RoleId: r.RoleId, RoleName: r.RoleName })}
                sx={{ fontSize: '12px' }}
              >
                {r.RoleName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 3 }} size="small" disabled={!role}>
          <InputLabel shrink sx={{background: '#fff', px:1}}>OU</InputLabel>
          <Select
            value={ou ? JSON.stringify(ou) : ''}
            onChange={(e) => setOu(JSON.parse(e.target.value))}
            sx={{ height: '30px' }}
          >
            {filteredOUs.map((m, i) => (
              <MenuItem
                key={i}
                value={JSON.stringify({ LocationId: m.LocationId, Location: m.Location })}
                sx={{ fontSize: '12px' }}
              >
                {m.Location}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose} sx={{ mr: 1, height: '30px' }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ height: '30px' }}
            disabled={!role || !ou}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
